import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-questionario-persona',
  templateUrl: './dialog-questionario-persona.component.html',
  styleUrls: ['./dialog-questionario-persona.component.scss']
})
export class DialogQuestionarioPersonaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
